import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiX, FiStar } = FiIcons;

const ExitIntentPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        const hasSeenPopup = sessionStorage.getItem('exitIntentShown');
        if (!hasSeenPopup) {
          setIsVisible(true);
          sessionStorage.setItem('exitIntentShown', 'true');
        }
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, []);

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-primary/60 backdrop-blur-sm">
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          className="relative w-full max-w-lg overflow-hidden bg-white shadow-2xl rounded-2xl"
        >
          <button
            onClick={() => setIsVisible(false)}
            className="absolute p-2 text-gray-400 top-4 right-4 hover:text-gray-600"
          >
            <SafeIcon icon={FiX} className="w-6 h-6" />
          </button>
          
          <div className="p-8 text-center sm:p-10">
            <div className="flex justify-center mb-6">
              <div className="flex items-center justify-center w-16 h-16 rounded-full bg-accent/20">
                <SafeIcon icon={FiStar} className="w-8 h-8 text-accent" />
              </div>
            </div>
            <h3 className="mb-4 text-2xl font-bold text-primary">Wait! Don't leave empty-handed.</h3>
            <p className="mb-8 text-gray-600">
              Start generating 5-star reviews today. Try Review Builder Pro completely free for 14 days. No credit card required.
            </p>
            <div className="flex flex-col gap-3 sm:flex-row justify-center">
              <button
                onClick={() => {
                  setIsVisible(false);
                  navigate('/free-trial');
                }}
                className="px-8 py-4 font-semibold text-white transition-colors rounded-lg bg-secondary hover:bg-secondary-hover"
              >
                Start My Free Trial
              </button>
              <button
                onClick={() => setIsVisible(false)}
                className="px-8 py-4 font-medium text-gray-600 transition-colors rounded-lg hover:bg-gray-100"
              >
                Maybe Later
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default ExitIntentPopup;